<ng-content></ng-content>
<div class="custom-file">
    <input type="file" formControlName="filename" class="custom-file-input1" id="customFile"
        (change)="fileChangeEvent($event)" [attr.accept]="acceptFilter">
    <label class="custom-file-label" for="customFile">{{fileMessagePlaceholder}}</label>
</div>